<script>
import { List, Cell, Col, Row, Image, Empty, DropdownMenu, DropdownItem, Toast, Tabs, Tab, Dialog } from 'vant'
import BottomToolbar from '@/components/org/BottomToolbar'
import ObjectFunc from '@/tbs/util/ObjectFunc'
import MatchTeam from '@/tbs/model/vo/MatchTeam'
import { QNImageUtil } from '@/utils'

const team = new MatchTeam

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-organization-list',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-list': List,
        'van-cell': Cell,
        'van-row': Row,
        'van-col': Col,
        'van-image': Image,
        'van-empty': Empty,
        'van-dropdown-menu': DropdownMenu,
        'van-dropdown-item': DropdownItem,
        'van-tabs': Tabs,
        'van-tab': Tab,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            matchId: null,
            matchGroupId: null,
            team: {
                teamList: null,
                matchRule: {
                    teamTotal: null,
                    groupTotal: null,
                    groupTeamTotal: null,
                    groupNameList: null,
                },
                roundList: null,
            },
            groupList: null,
            groupTeamList: null,
            selectedTabIndex: 0,
            selectedStatus: '0',
            selectedDivision: '0',
            locale: {}
        }
    },

    //--------------------------------------------------
    // component computed
    //--------------------------------------------------
    computed: {
        isTeamListEmtpy() {
            console.log('isTeamListEmtpy', this.team.teamList, ObjectFunc.isEmpty(this.team.teamList))
            return this.team.teamList && ((this.team.teamList.length == 0) || ObjectFunc.isEmpty(this.team.teamList))
        },
        statusOptions() {
            return team.statusOptions
        },
        divisionOptions() {
            return team.getDivisionOptions(this.groupList)
        },
        filteredTeamList() {
            console.log('selectedDivision', this.selectedDivision, this.team.teamList)
            if (this.selectedDivision == '0') {
                return this.team.teamList
            }
            else if (this.selectedDivision == '1') {
                return this.team.teamList.filter(item => (item.groupId == null))
            }
            else {
                return this.team.teamList.filter(item => (item.groupId === this.selectedDivision))
            }
        },
        countTeamNum() {
            let teamCount = '0'
            if (this.team.teamList && this.team.teamList.length) {
                teamCount = this.team.teamList.length.toString()
            }
            if (this.locale.localeProp) {
                return this.locale.localeProp('team-count-num', {num: teamCount})
            }
            return ''
        },
        totalTeamNum() {
            const teamTotal = this.team.matchRule.teamTotal
            if (this.locale.localeProp) {
                return this.locale.localeProp('team-total-num', {num: teamTotal})
            }
            return ''
        },
        teamOperatorIconButtons() {
            return [
                { type: 'invite-team', iconType: 'vant', icon: 'wechat', label: this.locale['invite'] },
                { type: 'create-team', icon: 'add', label: this.locale['create'] },
            ]
        },
        countGroupNum() {
            if (this.locale.localeProp && this.groupTeamList) {
                return this.locale.localeProp('group-count-num', {num: this.groupTeamList.filter(item => (item.teamList.length == this.team.matchRule.groupTeamTotal)).length.toString()})
            }
            return ''
        },
        totalGroupNum() {
            const groupTotal = this.team.matchRule.groupTotal
            if (this.locale.localeProp) {
                return this.locale.localeProp('group-total-num', {num: groupTotal})
            }
            return ''
        },
    },

    //--------------------------------------------------
    // component watch
    //--------------------------------------------------
    watch: {
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        isItemSelected(item) {
            // console.log('isItemSelected', item.id, this.selectedOrganizationId)
            return item.id === this.selectedOrganizationId
        },
        onTabChange(index) {
            console.log('onTabChange', index)
            this.$emit('custom-event', {
                type: 'load',
                data: {
                    index: index,
                }
            })
        },
        onTeamItemClick(item) {
            console.log('onTeamItemClick', item)
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgManageTeam',
                    params: {
                        id: item.id
                    },
                    query: {
                        matchGroupId: this.matchGroupId,
                        matchId: this.matchId
                    }
                }
            })
        },
        onTeamBottomToolbarIconClick(type) {
            if (type == 'invite-team') {
                this.onInviteBtnClick()
            }
            else if (type == 'create-team') {
                this.onCreateBtnClick()
            }
        },
        onCreateBtnClick() {
            console.log('onCreateBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgCreateTeam',
                    query: {
                        matchGroupId: this.matchGroupId
                    }
                }
            })
        },
        onInviteBtnClick() {
            console.log('onInviteBtnClick')
            Toast(this.locale['coming-soon'])
        },
        onTeamRateBtnClick() {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgEditMatchRule',
                    params: {
                        id: this.matchGroupId
                    },
                    query: {
                        matchId: this.matchId
                    }
                }
            })
        },
        onGroupItemClick(group) {
            console.log('onGroupItemClick', group)
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgEditGroup',
                    params: {
                        id: group.id
                    },
                    query: {
                        groupName: this.groupNameLabel(group.name),
                        stageId: this.team.roundList[0].stageId,
                        matchId: this.matchId,
                        matchGroupId: this.matchGroupId,
                        groupTeamTotal: this.team.matchRule.groupTeamTotal
                    }
                }
            })
        },
        onGroupRateBtnClick() {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgEditMatchRule',
                    params: {
                        id: this.matchGroupId
                    },
                    query: {
                        matchId: this.matchId
                    }
                }
            })
        },
        onGroupResetBtnClick() {
            console.log('onGroupResetBtnClick')
            Dialog.confirm({
                title: this.locale['reset-all-group'],
                message: this.locale['reset-all-group-confirm-message']
            }).then(() => {
                // on confirm
                this.$emit('custom-event', {
                    type: 'reset',
                    data: {
                        matchGroupId: this.matchGroupId,
                        stageId: this.team.roundList[0].stageId
                    }
                })
            }).catch(() => {
                // on cancel
            })
        },
        groupSeqLabel(seq) {
            // console.log('groupSeqLabel', seq)
            return this.locale.localeProp('group-seq-label', {num: ObjectFunc.pad(seq + 1, 2)}) 
        },
        groupNameLabel(name) {
            if (name == null) {
                return ''
            }
            else {
                return name + this.locale.localeProp('group-unit')
            }
        },
        groupTeamRateLabel(teamList) {
            return this.locale.localeProp('group-team-num-rate', {num: teamList.length.toString(), total: this.team.matchRule.groupTeamTotal})
        },
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
    },
}
</script>

<template>
    <div class="match-team-list">
        <van-tabs sticky
            offset-top="43"
            v-model="selectedTabIndex"
            @change="onTabChange"
        >
            <van-tab :title="locale['team-list']">
                <van-dropdown-menu class="van-hairline--bottom">
                    <van-dropdown-item
                        v-model="selectedStatus"
                        :options="statusOptions"
                        disabled
                    />
                    <van-dropdown-item
                        v-model="selectedDivision"
                        :options="divisionOptions"
                        :disabled="groupList == null"
                    />
                </van-dropdown-menu>
                <div v-if="!isTeamListEmtpy">
                    <van-list>
                        <van-cell 
                            v-for="item in filteredTeamList" 
                            :key="item.id" 
                            center
                            is-link
                            @click="onTeamItemClick(item)"
                        >
                            <template #title>
                                <div>
                                    <van-row>
                                        <van-col>
                                            <van-image
                                                v-if="item.logoUrl"
                                                :src="adjustImageSize(item.logoUrl, 120, 120)"
                                                fit="cover"
                                                width="60px"
                                                height="60px"
                                            />
                                            <img
                                                v-else
                                                src="@/assets/org/logo-symbol.png" 
                                                style="width: 60px; height: 60px;"
                                            />
                                        </van-col>
                                        <van-col :span="18" class="u-inner-margin">
                                            <div>
                                                <span class="main-text main-color">{{ item.name }}</span>
                                                <span class="pull-right minor-text minor-color">{{ groupNameLabel(item.groupName) }}</span>
                                            </div>
                                            <div>
                                                <span class="minor-text minor-color r-outer-margin">
                                                    <span class="r-inner-margin">{{ item.memberTotal }}</span>
                                                    <span>{{ locale['player-unit'] }}{{ locale.player }}</span>
                                                </span>
                                                <span class="minor-text minor-color">
                                                    <span class="r-inner-margin">{{ item.entryTotal }}</span>
                                                    <span>{{ locale['entry-unit'] }}{{ locale.entry }}</span>
                                                </span>
                                            </div>
                                        </van-col>
                                    </van-row>
                                </div>
                            </template>
                        </van-cell>
                    </van-list>
                </div>
                <div v-else @click="onCreateBtnClick">
                    <van-empty 
                        :description="locale['team-empty-hint']"
                        image="search"
                    />
                </div>
                <bottom-toolbar
                    type="rate-icons"
                    :minorRateCountLabel="countTeamNum"
                    :minorRateTotalLabel="totalTeamNum"
                    :minorRateLink="true"
                    :mainIcons="teamOperatorIconButtons"
                    @click-minor-rate="onTeamRateBtnClick"
                    @click-main-icon="onTeamBottomToolbarIconClick"
                />
            </van-tab>
            <van-tab v-if="team.matchRule.groupTotal > 1" :title="locale['groups']">
                <div class="bg-white u-outer-padding">
                    <div 
                        v-for="group in groupTeamList" 
                        :key="group.id" 
                        class="group-unit relative b-outer-margin"
                        @click="onGroupItemClick(group)"
                    >
                        <van-row>
                            <van-col span="6" class="text-center">
                                <div class="group-seq">
                                    <span class="minor-text main-color">{{ groupSeqLabel(group.seq) }}</span>
                                </div>
                                <div class="group-name t-inner-margin">
                                    <span class="text-title main-color">{{ groupNameLabel(group.name) }}</span>
                                </div>
                            </van-col>
                            <van-col span="18">
                                <div class="team-rate">
                                    <span class="minor-text minor-color">{{ groupTeamRateLabel(group.teamList) }}</span>
                                </div>
                                <div class="team-section t-inner-margin">
                                    <div 
                                        v-for="item in group.teamList" 
                                        :key="item.id" 
                                        class="inline-block r-outer-margin w50"
                                    >
                                        <div class="team-logo-wrapper h50">
                                            <img v-if="item.badge" style="width: 50px; height: 50px;" :src="adjustImageSize(item.badge, 100, 100)"/>
                                            <img v-else
                                                src="@/assets/org/logo-symbol.png"
                                                style="width: 50px; height: 50px;"
                                            />
                                        </div>
                                        <div class="team-name text-center t-inner-margin b-outer-margin">
                                            <span class="support-text minor-color van-ellipsis block">{{ item.name }}</span>
                                        </div>
                                    </div>
                                </div>
                            </van-col>
                        </van-row>
                        <div class="separator-line-bottom"/>
                    </div>
                </div>
                <bottom-toolbar
                    type="rate-button"
                    :minorRateCountLabel="countGroupNum"
                    :minorRateTotalLabel="totalGroupNum"
                    :minorRateLink="true"
                    :mainButtonLabel="locale['reset']"
                    @click-minor-rate="onGroupRateBtnClick"
                    @click-main-button="onGroupResetBtnClick"
                />
            </van-tab>
        </van-tabs> 
    </div>
</template>

<style scoped>
.group-unit {
    min-height: 105px;
}
</style>